import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import AOS from 'aos';
import 'aos/dist/aos.css';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner7 from '../assets/banner7.jpg';
import service1 from '../assets/banner1.jpg';


import map from '../assets/map.png';

import { IoMdAlert, IoMdArrowDropright, IoMdCheckmarkCircleOutline, IoMdDocument } from "react-icons/io";
import { FaArrowCircleRight, FaCalendarAlt, FaCogs, FaSearch, FaSeedling, FaSyncAlt, FaTachometerAlt, FaUsersCog } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneService from "./OneService";
import { TbDeviceCctv } from "react-icons/tb";
import { FaComputer, FaGun, FaPeopleGroup } from "react-icons/fa6";
import { MdCorporateFare } from "react-icons/md";


export default function ServicesBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	useEffect(() => {
    AOS.init({ duration: 1000, easing: 'ease-in-out', once: false });
    AOS.refresh(); // optional: refresh if content changes dynamically
  }, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-background"
				style={{
					paddingBottom: "50px",
				}}
			>
				<div 
					className="container"
					
				>
					
					<div className="row mt-5">

						<div 
							className="col-md-12"
						>
							<div className="row">
								<div className="col-md-12">
									<h3 className="text-primary font-semi-bold mb-5">
										Consultation Services
									</h3>
								</div>
								<div 
									onClick={() => {
										appContext.navTo({
											item: "services",
											subItem: "monitoring&evaluation"
										})
									}}
									className="col-12 services" data-aos="fade-right">
									<div className="row">
										<div className="flex-shrink-0 bg-secondary col-md-3 d-flex align-items-center justify-content-center py-3">
											<FaTachometerAlt size={68} />
										</div>
										<div className="col-md-9 p-3" style={{ background: "#295e3b3b" }}>
											<h6 className="font-bold">Monitoring and Evaluation (M&E)</h6>
											<hr />
											<p style={{ textAlign: "justify" }}>
												Our M&E framework applies evaluation standards to enhance accountability,
												efficiency, and impact measurement for development initiatives.
											</p>
											<div className="text-end">View More... <IoMdArrowDropright size={32} /></div>
										</div>
										
									</div>
								</div>

								<div 
									onClick={() => {
										appContext.navTo({
											item: "services",
											subItem: "project_planning"
										})
									}}
									className="col-12 mt-4 services" data-aos="fade-down">
									<div className="row">
										<div className="flex-shrink-0 bg-secondary col-md-3 d-flex align-items-center justify-content-center py-3">
											<FaCalendarAlt size={68} />
										</div>
										<div className="col-md-9 p-3" style={{ background: "#295e3b3b" }}>
											<h6 className="font-bold">Project Planning and Management</h6>
											<hr />
											<p style={{ textAlign: "justify" }}>
												We deliver project planning and management services with a proven track record 
												in implementing large-scale international and local initiatives.
											</p>
											<div className="text-end">View More... <IoMdArrowDropright size={32} /></div>
										</div>
									</div>
								</div>

								<div 
									onClick={() => {
										appContext.navTo({
											item: "services",
											subItem: "research"
										})
									}}
									className="col-12 mt-4 services" data-aos="fade-right">
									<div className="row">
										<div className="flex-shrink-0 bg-secondary col-md-3 d-flex align-items-center justify-content-center py-3">
											<FaSearch size={68} />
										</div>
										<div className="col-md-9 p-3" style={{ background: "#295e3b3b" }}>
											<h6 className="font-bold">Research Services</h6>
											<hr />
											<p style={{ textAlign: "justify" }}>
												Our experts provide high-quality, data-driven research solutions in social, 
												economic, and market studies for both local and international clients.
											</p>
											<div className="text-end">View More... <IoMdArrowDropright size={32} /></div>
										</div>
									</div>
								</div>

								<div 
									onClick={() => {
										appContext.navTo({
											item: "services",
											subItem: "HR_management"
										})
									}}
									className="col-12 mt-4 services" data-aos="fade-down">
									<div className="row">
										<div className="flex-shrink-0 bg-secondary col-md-3 d-flex align-items-center justify-content-center py-3">
											<FaUsersCog size={68} />
										</div> 
										<div className="col-md-9 p-3" style={{ background: "#295e3b3b" }}>
											<h6 className="font-bold">Capacity Building & Human Resource Management</h6>
											<hr />
											<p style={{ textAlign: "justify" }}>
												We empower organizations through customized training, leadership programs,
												and HR solutions aimed at improving performance and retention.
											</p>
											<div className="text-end">View More... <IoMdArrowDropright size={32} /></div>
										</div>
									</div>
								</div>

								{/* Outsourcing, Procurement & Contract Management */}
								<div 
									onClick={() => {
										appContext.navTo({
											item: "services",
											subItem: "outsorcing"
										})
									}}
									className="col-12 mt-4 services" data-aos="fade-right">
									<div className="row">
										<div className="flex-shrink-0 bg-secondary col-md-3 d-flex align-items-center justify-content-center py-3">
											<FaCogs size={68} />
										</div>
										<div className="col-md-9 p-3" style={{ background: "#295e3b3b" }}>
											<h6 className="font-bold">Outsourcing, Procurement & Contract Management</h6>
											<hr />
											<p style={{ textAlign: "justify" }}>
												We provide expert procurement and contract management services ensuring 
												compliance, value for money, and adherence to global standards.
											</p>
											<div className="text-end">View More... <IoMdArrowDropright size={32} /></div>
										</div>
									</div>
								</div>

								<div 
									onClick={() => {
										appContext.navTo({
											item: "services",
											subItem: "IT"
										})
									}}
									className="col-12 mt-4 services" data-aos="fade-right">
									<div className="row">
										<div className="flex-shrink-0 bg-secondary col-md-3 d-flex align-items-center justify-content-center py-3">
											<FaComputer size={68} />
										</div>
										<div className="col-md-9 p-3" style={{ background: "#295e3b3b" }}>
											<h6 className="font-bold">Information, Communications and Technology Services</h6>
											<hr />
											<p style={{ textAlign: "justify" }}>
												Free and Open-Source Software (FOSS) and Technologies, Design and development of systems, Information technology, communications and information systems consulting.
											</p>
											<div className="text-end">View More... <IoMdArrowDropright size={32} /></div>
										</div>
									</div>
								</div>

								<div 
									onClick={() => {
										appContext.navTo({
											item: "services",
											subItem: "Re-engineering"
										})
									}}
									className="col-12 mt-4 services" data-aos="fade-right">
									<div className="row">
										<div className="flex-shrink-0 bg-secondary col-md-3 d-flex align-items-center justify-content-center py-3">
											<FaSyncAlt size={68} />
										</div>
										<div className="col-md-9 p-3" style={{ background: "#295e3b3b" }}>
											<h6 className="font-bold">Business Process Re-engineering</h6>
											<hr />
											<p style={{ textAlign: "justify" }}>
												 We draw from our collected experiences in various industries we have worked with and our clients own understanding of their industries to review and model the business processes in organizations. 
											</p>
											<div className="text-end">View More... <IoMdArrowDropright size={32} /></div>
										</div>
									</div>
								</div>

								<div 
									onClick={() => {
										appContext.navTo({
											item: "services",
											subItem: "agriculture"
										})
									}}
									className="col-12 mt-4 services" data-aos="fade-down">
									<div className="row">
										<div className="flex-shrink-0 bg-secondary col-md-3 d-flex align-items-center justify-content-center py-3">
											<FaSeedling size={68} />
										</div>
										<div className="col-md-9 p-3" style={{ background: "#295e3b3b" }}>
											<h6 className="font-bold">Agriculture and Value Chain Strategies</h6>
											<hr />
											<p style={{ textAlign: "justify" }}>
												We conduct agricultural research, value chain analysis, and training to enhance 
												sustainable farming, market access, and food security.
											</p>
											<div className="text-end">View More... <IoMdArrowDropright size={32} /></div>
										</div>
									</div>
								</div>

							</div>
						</div>

						<div className="col-md-12 my-5 p-5 rounded bg-surface">
								<div className="row">
									<div className="col-md-9">
										<h3 className="text-primary font-semi-bold mb-3">
											REGIONAL REACH
										</h3>
										<h5 className="font-semi-bold">
											Our experience spans in Tanzania, Kenya, Uganda, Rwanda, Ghana, Malawi, Mozambique, Burkina Faso, Zambia, and Mali.
										</h5>
									</div>
									<div className="col-md-3">
										<img src={map} style={{width: "100%"}} className="rounded m-auto" />
									</div>
								</div>
						</div>
					</div>

				</div>
					
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
